import { fontSizeAdaptative } from 'utils/style/font';
import Flex from 'utils/style/flex';
import {
  colorSchema,
  gridSizes,
  themeBaseOverwrite,
  textSizes,
  gridSizesNumber,
  weights,
  fontSizes,
} from 'utils/style/theme';

import GlobalStyles from 'utils/style/global';
import media from 'utils/style/media';
import baseSelectItem from 'utils/style/baseSelectItem';
import zIndexses from 'utils/style/zIndexses';

const sameHeightWidth = (size) => `
  height: ${size};
  width: ${size};
`;

const expandHeightAndWidth = () => `
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;

export {
  Flex,
  colorSchema,
  gridSizes,
  fontSizes,
  weights,
  themeBaseOverwrite,
  textSizes,
  gridSizesNumber,
  sameHeightWidth,
  expandHeightAndWidth,
  fontSizeAdaptative,
  GlobalStyles,
  media,
  baseSelectItem,
  zIndexses,
};
